export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11113.4df5c909.jpg";